import reviewsActions from './loadReviews'
import languageActions from './language'

module.exports = {
    ...reviewsActions,
    ...languageActions,
}



// WEBPACK FOOTER //
// ./src/actions/index.js